module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface: Maoz Azaryahu and Ilan Troen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction: Tel-Aviv Imagined and Realized")]), _vm._v(" / "), _c('em', [_vm._v("S. Ilan Troen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("PART 1 HISTORICAL ISSUES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1"
    }
  }, [_vm._v("1 Telling the Story of a Hebrew City")]), _vm._v(" / "), _c('em', [_vm._v("Yaacov Shavit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2"
    }
  }, [_vm._v("2 Tel-Aviv’s Birthdays: Anniversary Celebrations, 1929–1959")]), _vm._v(" / "), _c('em', [_vm._v("Maoz Azaryahu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3"
    }
  }, [_vm._v("3 Tel-Aviv’s Foundation Myth: A Constructive Perspective")]), _vm._v(" / "), _c('em', [_vm._v("Hizky Shoham")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 From “European Oasis” to Downtown New York: The Image of Tel-Aviv in School Textbooks")]), _vm._v(" / "), _c('em', [_vm._v("Yoram Bar-Gal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Subversive Youth Cultures in Mandate Tel-Aviv")]), _vm._v(" / "), _c('em', [_vm._v("Tammy Razi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Dirt, Noise, and Misbehavior in the First Hebrew City: Letters of Complaint as a Historical Source")]), _vm._v(" / "), _c('em', [_vm._v("Anat Helman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 South of Tel-Aviv and North of Jaffa—The Frontier Zone of “In Between”")]), _vm._v(" / "), _c('em', [_vm._v("Deborah S. Bernstein")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Jaffa and Tel-Aviv before 1948: The Underground Story")]), _vm._v(" / "), _c('em', [_vm._v("Nahum Karlinsky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Austerity Tel-Aviv: Everyday Life, Supervision, Compliance, and Respectability")]), _vm._v(" / "), _c('em', [_vm._v("Orit Rozin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2 LANGUAGE, LITERATURE, AND ART")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Tel-Aviv Language Police")]), _vm._v(" / "), _c('em', [_vm._v("Zohar Shavit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 "), _c('em', [_vm._v("Der Eko Fun Goles:")]), _vm._v(" “The Spirit of Tel-Aviv” and the Remapping of Jewish Literary History")]), _vm._v(" / "), _c('em', [_vm._v("Barbara Mann")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 A Poet and a City in Search of a Myth: On Shlomo Skulsky’s Tel-Aviv Poems")]), _vm._v(" / "), _c('em', [_vm._v("Aminadav Dykman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Decay and Death: Urban Topoi in Literary Depictions of Tel-Aviv")]), _vm._v(" / "), _c('em', [_vm._v("Rachel S. Harris")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Art and the City: The Case of Tel-Aviv")]), _vm._v(" / "), _c('em', [_vm._v("Dalia Manor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3 PLANNING AND ARCHITECTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The 1925 Master Plan for Tel-Aviv by Patrick Geddes")]), _vm._v(" / "), _c('em', [_vm._v("Volker M. Welter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Preserving Urban Heritage: From Old Jaffa to Modern Tel-Aviv")]), _vm._v(" / "), _c('em', [_vm._v("Nurit Alfasi and Roy Fabian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Balconies of Tel-Aviv: Cultural History and Urban Politics")]), _vm._v(" / "), _c('em', [_vm._v("Carolin Aronis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 The Architecture of the Hyphen: The Urban Unification of Jaffa and Tel-Aviv as National Metaphor")]), _vm._v(" / "), _c('em', [_vm._v("Alona Nitzan-Shiftan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: Tel-Aviv between Province and Metropolis")]), _vm._v(" / "), _c('em', [_vm._v("Maoz Azaryahu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0